module.exports = __webpack_public_path__ + "img/447072_8ACACB_65A4A5_74B3B3-256px.ae876d4a.png";